import { PERMISOS } from 'const/Permisos';
import * as yup from 'yup';

const schemaMatchManual = isTienePermisos => {
  let schema = {};

  if (
    isTienePermisos(PERMISOS.matchFiltroNegocio) &&
    isTienePermisos(PERMISOS.matchFiltroSucursal) &&
    isTienePermisos(PERMISOS.matchFiltroResiduo) &&
    isTienePermisos(PERMISOS.matchFiltroRecursos)
  ) {
    //SUPERADMIN : Tiene todos los permisos
    //Los campos obligatorios solo son empresa-sucursal o residuos o recursos.
    schema = {
      empresa: yup
        .object()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio'),
      sucursal: yup
        .object()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio')
    };

    return yup.object().shape(schema);
  }

  if (isTienePermisos(PERMISOS.matchFiltroNegocio)) {
    schema.empresa = yup
      .object()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio');
  }
  if (isTienePermisos(PERMISOS.matchFiltroSucursal)) {
    schema.sucursal = yup
      .object()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio');
  }
  if (isTienePermisos(PERMISOS.matchFiltroResiduo)) {
    schema.codigosTipoResiduo = yup
      .object()
      .typeError('Este campo es obligatorio');
  }
  if (isTienePermisos(PERMISOS.matchFiltroRecursos)) {
    schema.codigosRecurso = yup.object().typeError('Este campo es obligatorio');
  }

  if (
    !isTienePermisos(PERMISOS.matchFiltroNegocio) &&
    !isTienePermisos(PERMISOS.matchFiltroSucursal)
  ) {
    schema.codigosTipoResiduo = yup
      .object()
      .nullable()
      .test(
        'Validacion de campo',
        'Debes completar un residuo o recurso',
        function (value) {
          const { parent } = this;
          return !!(parent.codigosTipoResiduo || parent.codigosRecurso);
        }
      );

    schema.codigosRecurso = yup
      .object()
      .nullable()
      .test(
        'Validacion de campo',
        'Debes completar un residuo o recurso',
        function (value) {
          const { parent } = this;
          return !!(parent.codigosTipoResiduo || parent.codigosRecurso);
        }
      );
  }

  return yup.object().shape(schema);
};

export { schemaMatchManual };
